import * as tslib_1 from "tslib";
import selectReplyOption from '../actions/selectReplyOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var REPLY_KEY = 'Reply';
var REPLY_ALL_KEY = 'ReplyAll';
var ReplyFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReplyFull, _super);
    function ReplyFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectReplyOption(option.key === REPLY_ALL_KEY);
        };
        return _this;
    }
    ReplyFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isReplyAllDefault = getFallbackValueIfNull(optionStore.replyAllByDefault, userOptions.IsReplyAllTheDefaultResponse);
        var selectedKey = isReplyAllDefault ? REPLY_ALL_KEY : REPLY_KEY;
        var choices = [
            {
                key: REPLY_KEY,
                text: strings.options_mail_Reply,
            },
            {
                key: REPLY_ALL_KEY,
                text: strings.options_mail_ReplyAll,
            },
        ];
        return (React.createElement(ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange, label: strings.options_mail_ReplyOptionLabel }));
    };
    ReplyFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], ReplyFull);
    return ReplyFull;
}(React.Component));
export default ReplyFull;
//# sourceMappingURL=ReplyFull.js.map